import React, { useRef, useState } from "react";
import moment from "moment";
import { kFormatter, percentageFormatter } from "../../Dashboard/Charts/utils";
import { Icon } from "semantic-ui-react";
import DimmerComponent from "../../Dashboard/DimmerComponent";
import NoData from "../../Dashboard/Charts/NoData/NoData";
import { Dropdown } from "semantic-ui-react";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import { ReactComponent as MoreOptions } from "../../../../assets/svg/menu.svg";
import { ReactComponent as CloneIcon } from "../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../assets/svg/settings.svg";
import { ReactComponent as DownloadIcon } from "../../../../assets/svg/downloads.svg";
import { ReactComponent as ArrowIcon } from "../../../../assets/svg/chevron.svg";
import { ReactComponent as MiniMize } from "../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../assets/svg/zoom_out_map.svg";
import ChartOptionsSidebar from "../../Dashboard/Charts/ChartsOptionsSidebar/ChartOptionsSidebar";
import DeleteWidget from "../../Dashboard/Charts/ChartsOptionsSidebar/DeleteWidget";
import { ChartFilterIcon } from "../../Dashboard/Charts/ChartFilterOptions";
import ChartName from "../../Dashboard/Charts/ChartName";
import html2canvas from "html2canvas";
import { downloadCSVData, downloadCanvasWithTitle } from "../../Dashboard/Charts/utils";
import FBIntervalSelector from "../FBIntervalSelector";
import "../../Dashboard/Charts/TotalValueCharts/TotalValueCharts.scss";
import FBPageSelector from "../FBPageSelector";
import UpIcon from "../../../../assets/svg/percentage_arrow.svg";
import DownIcon from "../../../../assets/svg/arrow-down.svg";
import Loading from "../../EnhancedInsights/modules/InstagramInsights/components/Loading/Loading";

function TotalReachCount(props) {
    const [downloading, setDownloading] = useState(false);
    const chartEl = useRef();
    let nodata = props.pageStatus || !props.data;

    let current = props.data?.totalReachCount?.curr;
    let previous = props.data?.totalReachCount?.prev;

    const renderDownloadButton = (nodata) => {
        return (
            <Dropdown
                disabled={nodata}
                trigger={
                    <div className="chart-header-icon">
                        <DownloadIcon className="chart-download-icon" />
                    </div>
                }
                icon={null}
                className="chart-download-dropdown hideable"
                direction="left">
                <Dropdown.Menu>
                    <Dropdown.Item onClick={downloadCSV}>CSV</Dropdown.Item>
                    <Dropdown.Item onClick={downloadPNG}>PNG</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        );
    };

    const downloadPNG = () => {
        if (props.isFreeTierPackage) {
            props.packageUpgradePopup();
            return;
        }
        setDownloading(true);

        return html2canvas(chartEl.current, { backgroundColor: "#fff" }).then((canvas) => {
            setDownloading(false);
            downloadCanvasWithTitle(canvas, props.widget?.name || "Total Reach");
        });
    };

    const downloadCSV = () => {
        if (props.isFreeTierPackage) {
            props.packageUpgradePopup();
            return;
        }
        const columns = [["Duration"], ["Current Total"], ["Previous Total"], ["Percentage Change"]];

        const formatString = "YYYY-MM-DD HH:mm";
        let tz = JSON.parse(localStorage.company).user_timezone_name;

        if (!["custom", "24HRS", "1", "lastmonth", "lastquarter", "last2quarter"].includes(props.appliedFilter.duration))
            columns[0].push(props.appliedFilter.duration + " days");
        else {
            const startDate = moment(props.appliedFilter.start_date);
            const endDate = moment(props.appliedFilter.end_date);
            const now = moment(new Date());
            const duration = moment.duration(endDate.diff(startDate, "days")) + 1;

            if (props.appliedFilter.duration === "24HRS") {
                const startDate = moment(new Date())
                    .tz(tz)
                    .subtract(1440 - 1, "minutes")
                    .format("YYYY-MM-DDTHH:mm:ss");
                const endDate = moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:ss");

                columns[0].push(`${moment(startDate).format(formatString)} - ${moment(endDate).format(formatString)}`);
            } else if (props.appliedFilter.duration === "1") {
                columns[0].push("Today");
            } else if (props.appliedFilter.duration === "custom") {
                if (props.appliedFilter.rollingDate) {
                    columns[0].push(`${startDate.format(formatString)} - ${now.format(formatString)}`);
                } else columns[0].push(`${startDate.format(formatString)} - ${endDate.format(formatString)}`);
            } else if (props.appliedFilter.duration === "lastmonth") {
                columns[0].push("Last Month");
            } else if (props.appliedFilter.duration === "lastquarter") {
                columns[0].push("Last Quarter");
            } else if (props.appliedFilter.duration === "last2quarter") {
                columns[0].push("Last 2 Quarters");
            } else {
                if (duration > 1) columns[0].push(duration + " days");
                else columns[0].push(duration + " day");
            }
        }
        columns[1].push(current);
        columns[2].push(previous);

        let percentageChange =
            previous === 0
                ? "N/A"
                : current > previous
                ? `+ve ${!isFinite((((current - previous) / previous) * 100).toFixed(2)) ? 0 : (((current - previous) / previous) * 100).toFixed(2)}%`
                : current === previous
                ? "0 %"
                : `-ve ${!isFinite((((previous - current) / previous) * 100).toFixed(2)) ? 0 : (((previous - current) / previous) * 100).toFixed(2)}%`;

        columns[3].push(percentageChange);

        let csvFmt = columns[0].map((col, i) => columns.map((row) => row[i]));
        downloadCSVData(csvFmt, props.widget?.name || "Total Reach");
    };

    const increment = () => {
        if (props.fbSelectedPageIds.length === 1) return;
        let index;
        props.fbSelectedPageIds.map((value, ind) => {
            if (value.id === props.selectedFbPage?.value) index = ind;
        });
        if (index === props.fbSelectedPageIds.length - 1) props.setSelectedFbPage(props.fbSelectedPageIds[0]);
        else props.setSelectedFbPage(props.fbSelectedPageIds[index + 1]);
    };

    const decrement = () => {
        if (props.fbSelectedPageIds.length === 1) return;
        let index;
        props.fbSelectedPageIds.map((value, ind) => {
            if (value.id === props.selectedFbPage?.value) index = ind;
        });
        if (index === 0) props.setSelectedFbPage(props.fbSelectedPageIds[props.fbSelectedPageIds.length - 1]);
        else props.setSelectedFbPage(props.fbSelectedPageIds[index - 1]);
    };

    const elements = (
        <>
            <div className="dashboard-widget-container-header skiptranslate">
                <ChartName isFacebook name={props.widget?.name || "Total Reach"} info="Total reach percentage change based on duration selection." />
                <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                    {!props.isFBPage &&
                        !props.isPublic &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <ChartFilterIcon
                                chartFilterApplied={props.chartFilterApplied}
                                changeShowChartFilterOptions={props.changeChartFilter}
                                widgetListDashboardCurrent={props.widgetListDashboardCurrent}
                                name={props.widget?.name}
                            />
                        )}
                    {!props.isPublic && !props.isResearchDashboard && !nodata && <>{renderDownloadButton(nodata)}</>}
                    {(props.isPublic && nodata) || props.isFBPage ? null : (
                        <Popup
                            className="skiptranslate"
                            trigger={
                                props.expand ? (
                                    <MiniMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                ) : (
                                    <MaxiMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                )
                            }
                            inverted
                            content={props.expand ? "Minimize Widget" : "Maximize Widget"}
                            size="mini"
                            position="bottom center"
                            style={{ zIndex: "99999" }}
                        />
                    )}
                    {(!props.isPublic && nodata) || props.isFBPage ? null : (
                        <MoreOptions
                            className={nodata && props.isFBPage ? "pointer-disabled" : "more-options"}
                            onClick={(e) => props.changeShowMoreOptions(e)}
                        />
                    )}
                </div>
            </div>
            {props.showMoreOptions && (
                <ChartOptionsSidebar
                    data-html2canvas-ignore="true"
                    showMoreOptionsLoc={props.showMoreOptionsLoc}
                    changeShowMoreOptions={props.changeShowMoreOptions}>
                    {/* {!nodata && (
                        <>
                            <FBIntervalSelector
                                aggs_val={props.aggs_val}
                                appliedFilter={props.appliedFilter}
                                handleIntervalChange={props.handleIntervalChange}
                            />
                        </>
                    )} */}
                    {!props.isFBPage &&
                        !props.isPublic &&
                        !props.isStandardDashboard &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <>
                                <div className="chart-settings menu-option" onClick={props.chartSettings}>
                                    <span>Chart Configuration</span>
                                    <Settings />
                                </div>
                                <div className="clone-chart menu-option" onClick={props.cloneWidget}>
                                    <span>Clone Chart</span>
                                    <CloneIcon />
                                </div>
                                <DeleteWidget onClick={props.deleteWidget} />
                            </>
                        )}
                </ChartOptionsSidebar>
            )}
            {!nodata ? (
                <div className="dashboard-chart dashboard-chart-slider skiptranslate" ref={chartEl}>
                    {!props.isFBPage && (
                        <div
                            data-html2canvas-ignore="true"
                            className={`chart-slider chart-slider-left ${props.fbSelectedPageIds.length === 1 ? "disabled" : ""}`}>
                            <ArrowIcon onClick={decrement} />
                        </div>
                    )}
                    <div className="chart-area">
                        {!props.isFBPage && props.selectedFbPage && (
                            <FBPageSelector
                                selectedFbPage={props.selectedFbPage}
                                setSelectedFbPage={props.setSelectedFbPage}
                                fbSelectedPageIds={props.fbSelectedPageIds}
                                widgetContainerRef={props.widgetContainerRef}
                            />
                        )}

                        <div className="chart__content">
                            {!(downloading || !props.selectedFbPage || props.loading) ? (
                                <>
                                    <div className="current__count">{kFormatter(current)}</div>
                                    <div className="zzz">
                                        <div className="chart__text">Reach</div>
                                        {previous === 0 ? (
                                            <div className="chart__percentage-wrapper">
                                                <div>N/A</div>
                                            </div>
                                        ) : current === previous ? (
                                            <div className="chart__percentage-wrapper">
                                                <div>0%</div>
                                            </div>
                                        ) : current > previous ? (
                                            <div className="chart__percentage-wrapper">
                                                <img src={UpIcon} className="up__icon" />
                                                <div className="percentage__count">
                                                    {percentageFormatter((((current - previous) / previous) * 100).toFixed(1))}%
                                                </div>
                                            </div>
                                        ) : previous > current ? (
                                            <div className="chart__percentage-wrapper">
                                                <img src={DownIcon} className="down__icon" />
                                                <div className="percentage__count-less">
                                                    {percentageFormatter((((previous - current) / previous) * 100).toFixed(1))}%
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>
                                </>
                            ) : (
                                <Loading />
                            )}
                        </div>
                    </div>
                    {!props.isFBPage && (
                        <div
                            data-html2canvas-ignore="true"
                            className={`chart-slider chart-slider-right ${props.fbSelectedPageIds.length === 1 ? "disabled" : ""}`}>
                            <ArrowIcon onClick={increment} />
                        </div>
                    )}
                </div>
            ) : (
                <NoData message={props.pageStatus ? "Page is Inactive. Please re-authenticate" : ""} />
            )}
        </>
    );

    return props.isFBPage ? <div className="dashboard-widget-container">{elements}</div> : <>{elements}</>;
}

export default TotalReachCount;
